import React from 'react';
import { Link, useMatch } from "../../../vendor/router-ROUTER_TARGET";

import IconGenres from './svg/IconGenres';
// import IconArrow from './svg/IconArrow';
// import { useSelector } from "react-redux";

function GenresMenu({ onClick }) {
  // const storeRoute = useSelector(state => state.storeRoute);
  let match = useMatch({ path: '/genres', end: false });
  const setHistory = () => {
    if (onClick) {
      onClick();
    }
    // storeRoute.goTo('/genres');
  }

  return (
    <div className={`menu-left-container ${match && `selected`} `} >
      <Link id={`link-ref-rp`} onClick={setHistory} style={{textDecoration: `none`}} to={'/genres'}>
        <div id={`ref-rp`} className={`flexRow align top-menu-container ${match && `selected`}`}>
          <IconGenres />
          <span className={`type-regular fz14`}>Genres</span>
          {/* <IconArrow size={22} color={'#8C8C8C'} className={'arrow-genre-menu'} /> */}
        </div>
      </Link>
    </div>     
  )
}

export default GenresMenu;
